/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";
// reactstrap components
import {
  Button,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  UncontrolledTooltip
} from "reactstrap";
import linkedin from "./linkedin.png";
import youtube from "./youtube.png";

class SimpleFooter extends React.Component {
  render() {
    return (
      <>
        <footer className=" footer" style={{ backgroundColor: "rgb(241, 241, 241)" }}>
          <br />
          <Container>
            <Row className=" row-grid align-items-center mb-5">
              <Col lg="8">
                <h3 className="font-weight-light mb-2">
                  RoundTable
                </h3>
                <h5 className=" mb-0 font-weight-light">
                  Reimagine voting. Reimagine governance. Reimagine decision making.
                </h5>
                <div style={{ marginTop: '10px' }}>
                  <a href="https://www.linkedin.com/company/makeroundtable" target="_blank">
                    <img src={linkedin} width="30" height="30" style={{ marginLeft: 'auto' }}></img>
                  </a>
                  <a href="https://www.youtube.com/channel/UClyjxCtVI0I1v-Ldjy1U0eg" target="_blank">
                    <img src={youtube} width="45" height="30" style={{ marginLeft: 'auto' }}></img>
                  </a>
                </div>
              </Col>
            </Row>
            <hr />
            <Row className=" align-items-center justify-content-md-between">
              <Col md="6">
                <div>
                  <a href="https://storyset.com/" target="_blank" style={{ marginLeft: "10px" }}>
                    Illustrations by Storyset
                  </a>
                </div>
              </Col>
              <Col md="6">
                <Nav className=" nav-footer justify-content-end">
                  <NavItem>
                    <NavLink href="/#/contactus">
                      Contact Us
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink href="/#/about">
                      About Us
                    </NavLink>
                  </NavItem>
                </Nav>
              </Col>
            </Row>
            <br />
          </Container>
        </footer>
      </>
    );
  }
}

function loadLinkedIn() {
  window.open("https://www.linkedin.com/company/makeroundtable", "_blank")
}

function loadYoutube() {
  window.open("https://www.youtube.com/channel/UClyjxCtVI0I1v-Ldjy1U0eg", "_blank")
}

export default SimpleFooter;
